// src/components/layout/Layout.tsx
import React from 'react';
import Header from './Header';
import Footer from './Footer';
import Head from './Head';
import ScrollToTop from '@/components/utils/ScrollToTop';

interface LayoutProps {
  children: React.ReactNode;
  title?: string;
  description?: string;
  keywords?: string;
}

const Layout: React.FC<LayoutProps> = ({ 
  children, 
  title, 
  description, 
  keywords 
}) => {
  return (
    <>
      <Head 
        title={title} 
        description={description} 
        keywords={keywords}
      />
      <div className="flex flex-col min-h-screen bg-gradient-to-b from-stone-50 to-stone-100">
        <Header />
        <main className="flex-grow">
          {children}
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
};

export default Layout;